import { faBuilding, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Chip, Stack } from '@vapor/material'
import { useCallback, useMemo } from 'react'
import { CustomerType } from 'src/api/api.generated'
import { HiCIcon } from '../icons/icon'

export type CustomerReference = {
  id: string
  name: string
  type: CustomerType
}

export type CustomerPickerProps = {
  customers: CustomerReference[]
  pickedCustomerId?: string | null
  onCustomerPicked?: (customerId: string | null) => void
}

export default function CustomerPicker({ customers, pickedCustomerId, onCustomerPicked }: CustomerPickerProps) {
  const onClick = useCallback(
    (id: string) => {
      if (onCustomerPicked) onCustomerPicked(id)
    },
    [pickedCustomerId, onCustomerPicked, customers],
  )

  if (customers.length <= 0) {
    return null
  }

  const uniqueCustomers = useMemo(() => {
    return customers.reduce((reduced: CustomerReference[], current: CustomerReference) => {
      if (!reduced.find((x) => x.id === current.id)) return [...reduced, current]
      return reduced
    }, [])
  }, [customers])

  return (
    <Stack direction="row" gap={1} flexWrap="wrap">
      {uniqueCustomers.map((c) => (
        <Chip //
          size="small"
          key={c.id}
          label={c.name}
          icon={
            <HiCIcon>
              <FontAwesomeIcon icon={c.type === CustomerType.PERSON ? faUser : faBuilding} />
            </HiCIcon>
          }
          variant={c.id === pickedCustomerId ? 'outlined' : 'filled'}
          onClick={() => onClick(c.id)}
        />
      ))}
    </Stack>
  )
}
